export const noResultsMessages = [
  "Sorry, nothing matches your vibe right now.",
  "Uh oh, looks like this part of the shore’s still sleeping it off...",
  "Sorry, couldn't find anything for that search.",
  "Sorry, looks like your ideal bar is closed.",
  "Sorry, no matches there — but we believe in you.",
  "Sorry, it's a little quiet out there right now.",
  "Uh oh, maybe it's not five o'clock somewhere...",
];
